module.exports = __webpack_public_path__ + "static/media/storyimg1.843496c3.png";